import React, { useState, useEffect } from "react";
import { useField } from "formik";
import { XIcon } from "@heroicons/react/outline";

const FormikInputDate: React.FC<any> = ({
  inlinelabel,
  defaultValue,
  minDate,
  ...props
}) => {
  const [dateValue, setDateValue] = useState<string | null>(defaultValue);
  const _field = useField(props);
  const field = _field[0];
  const { setValue } = _field[2];

  useEffect(() => {
    if (dateValue) setValue(dateValue);
    else setValue(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateValue]);

  return (
    <div className="flex items-center">
      <div style={{ padding: "5px 0px" }} className="w-full">
        <label className="text-gray-400 text-sm">{inlinelabel}</label>
        <input
          type="date"
          id="date_demo"
          min={minDate || ""}
          value={dateValue || ""}
          name={field.name}
          onChange={(e) => setDateValue(e.target.value)}
          className="py-1 px-2 focus:ring-0 font-semibold border-0 border-b border-gray-300 outline-none text-gray-800 w-full"
        />
      </div>
      <span
        onClick={() => setDateValue(null)}
        className="text-blue-500 cursor-pointer mt-5"
      >
        <XIcon className="h-5 w-5" />
      </span>
    </div>
  );
};

export default FormikInputDate;
